export class MailAddress {
    mailAddress = "";
}
